// Temporary canvas-only styles. Nothing is written to the block or undo history.
export function previewHtmlTypography(elements, values) {
    const originals = [];
    for (const element of elements) {
        for (const property of ['font-family', 'font-size', 'font-weight']) {
            const value = values[property]?.trim();
            if (!value || /[;{}<>]/.test(value)) continue;
            if (typeof CSS !== 'undefined' && CSS.supports && !CSS.supports(property, value)) continue;
            originals.push({ element, property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property), hadStyle: element.hasAttribute('style') });
            element.style.setProperty(property, value, 'important');
        }
    }
    return () => {
        for (const original of originals.reverse()) {
            if (original.value) original.element.style.setProperty(original.property, original.value, original.priority);
            else original.element.style.removeProperty(original.property);
            if (!original.hadStyle && !original.element.style.length) original.element.removeAttribute('style');
        }
    };
}
